import { TZDate } from '@date-fns/tz';
import { useTexts, useTranslation } from '@/feature/lang';
import { getUtcOffsetWithSign } from '@/util/time';
import { useTimeZone } from './TimeZoneContext';

export const ActiveTimeZone = () => {
  const { translate } = useTranslation();
  const texts = useTexts().feature.timeZone;
  const timeZone = useTimeZone();

  const tzDate = new TZDate(new Date(), timeZone);
  const offset = getUtcOffsetWithSign(tzDate);

  return <>{translate(texts.activeTimeZone, { offset })}</>;
};
